import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-318d6090"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "login-register" }


import { ref, defineComponent, onMounted } from 'vue'
import { apiPostData, getI18n } from '../utils'
import { apiLoginPath } from '../config'

// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'LoginView'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const refLoginForm = ref({
  account: '',
  password: '',
  errorMessage: ''
})
const refLoginRules = ref({
  account: [
    { required: true, message: getI18n('请输入') + getI18n('用户名'), trigger: 'blur' }
  ],
  password: [
    { required: true, message: getI18n('请输入') + getI18n('密码'), trigger: 'blur' }
  ]
})
const refShow = ref(false)
const loginFormRef = ref()

function login () {
  console.log(refLoginForm.value.password)
  loginFormRef.value.validate(valid => {
    if (valid) {
      apiPostData(apiLoginPath, { account: refLoginForm.value.account, password: refLoginForm.value.password })
        .then(response => {
          console.log('login', response)
          let success = true
          if (response === undefined || response === null) {
            // 在 apiPostData 中跳转是 response 为空
            // refLoginForm.value.errorMessage = 'unknow error'
            success = false
          } else {
            success = response.success
            refLoginForm.value.errorMessage = response.errmsg
          }
          if (success) {
            window.location.href = '/'
          }
        })
    } else {
      console.log('登录表单验证失败')
      return false
    }
  })
}
onMounted(async () => {
  refShow.value = true
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (refShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            model: refLoginForm.value,
            ref_key: "loginFormRef",
            ref: loginFormRef,
            rules: refLoginRules.value,
            "label-width": "80px",
            class: "login-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(getI18n)('用户名'),
                prop: "account"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: refLoginForm.value.account,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refLoginForm.value.account) = $event)),
                    placeholder: _unref(getI18n)('请输入') + _unref(getI18n)('用户名')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(getI18n)('密码'),
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "password",
                    modelValue: refLoginForm.value.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refLoginForm.value.password) = $event)),
                    placeholder: _unref(getI18n)('请输入') + _unref(getI18n)('密码')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              (refLoginForm.value.errorMessage!=='')
                ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_text, {
                        class: "mx-1",
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(refLoginForm.value.errorMessage), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: login
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('登录')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})